module.exports = __webpack_public_path__ + "img/WholeLifeOptions.d2ff83b6.png";